import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MemorySymbolV1 } from '../MemorySymbolV1';
import { MemoryRangeV1 } from '../MemoryRangeV1';
import { DEFAULT_SIGN_VALUE, getSignLevel } from '../../shared/memory-map-helpers';
import styles from './QuestionSignSlideV1.css';

const SYMBOL_SIZE = 170;

function QuestionSignSlideV1({ id, question, hint, symbol, ends, submitTemporaryAnswer, userResponse = {} }) {
    const [value, setValue] = useState(userResponse?.value ?? DEFAULT_SIGN_VALUE);

    useEffect(() => {
        const level = getSignLevel(value);

        submitTemporaryAnswer({ id: 1, questionId: id, question, text: ends[level - 1], value, level });
    }, [value]);

    return (
        <div className={styles.form} key={id}>
            <div className={styles.text}>
                <h1 className={styles.question}>{question}</h1>
                <p className={styles.hint}>{hint}</p>
            </div>
            <div className={styles.slider}>
                <div className={styles.view}>
                    <MemorySymbolV1 type={symbol} value={value} size={SYMBOL_SIZE} />
                </div>
                <MemoryRangeV1
                    value={value}
                    onChange={setValue}
                    label={question}
                    ends={ends}
                />
            </div>
        </div>
    );
}

QuestionSignSlideV1.propTypes = {
    id: PropTypes.number.isRequired,
    question: PropTypes.string.isRequired,
    hint: PropTypes.string,
    symbol: PropTypes.oneOf(['stone', 'shape', 'glow']).isRequired,
    ends: PropTypes.arrayOf(PropTypes.string).isRequired,
    submitTemporaryAnswer: PropTypes.func.isRequired,
    userResponse: PropTypes.object
};

export {
    QuestionSignSlideV1
};
